
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public MenuAbierto: boolean = false;
        public Buscador: string = '';
        public Estado: string = '';
        public SubModo: string = '';
        public Modo: string = '';
        @Watch( 'Modo' )
        onModo()
        {
            if ( this.Controlador.Vista.Modo != this.Modo )
            {
                this.Controlador.Vista.Modo = this.Modo;
            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Buscador = this.Controlador.Vista.Buscador;
            this.Estado = this.Controlador.Vista.Estado;
            this.Modo = this.Controlador.Vista.Modo;
            this.Eventos.push( this.Controlador.Vista.onBuscador.subscribe( () => this.Buscador = this.Controlador.Vista.Buscador ) );
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );
            this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () => this.Modo = this.Controlador.Vista.Modo ) );
            this.Eventos.push( this.Controlador.Vista.onSubModo.subscribe( () => this.SubModo = this.Controlador.Vista.SubModo ) );
            this.Eventos.push( this.Controlador.Vista.onMenuAbierto.subscribe( () => this.MenuAbierto = this.Controlador.Vista.MenuAbierto ) );

        }
    }
